import Sidebar from "./Sidebar";

import "./Sidebar.scss";

export default Sidebar;